import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/date_range_black.svg'


const _hoisted_1 = { class: "date-picker-wrapper" }
const _hoisted_2 = { class: "date default-text" }
const _hoisted_3 = { class: "default-text-orange" }
const _hoisted_4 = { class: "date-flex-wrap" }
const _hoisted_5 = { class: "calendar-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "calendar-icon",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "date-button-wrapper" }
const _hoisted_8 = { class: "time-section-container" }
const _hoisted_9 = { class: "time-section-container-one" }
const _hoisted_10 = { class: "date-section-name-container" }
const _hoisted_11 = { class: "date-section-name default-text" }
const _hoisted_12 = { class: "default-text-orange" }
const _hoisted_13 = { class: "time-selector-container" }
const _hoisted_14 = { class: "time-suggestion-wrapper" }
const _hoisted_15 = { class: "time-suggestion-buttons-wrapper" }
const _hoisted_16 = {
  key: 0,
  class: "time-suggestion-text-container"
}
const _hoisted_17 = { class: "time-suggestion-text small-text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ta_button = _resolveComponent("ta-button")!
  const _component_time_selector = _resolveComponent("time-selector")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t("DateAndTime.date")), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.requiredSymbol), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
            onCleared: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearDate())),
            onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDateValue(_ctx.date))),
            autoApply: "",
            monthChangeOnScroll: 'inverse',
            format: _ctx.format,
            closeOnAutoApply: true,
            enableTimePicker: false,
            minDate: _ctx.minmalAllowedValue,
            maxDate: new Date()
          }, null, 8, ["modelValue", "format", "minDate", "maxDate"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ta_button, {
            class: _normalizeClass(["date-button-yesterday", {
              'not-selected': _ctx.selectedDate !== _ctx.yesterdayDate,
            }]),
            text: 'Yesterday',
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.yesterday()))
          }, null, 8, ["class"]),
          _createVNode(_component_ta_button, {
            class: _normalizeClass(["date-button-today", {
              'not-selected': _ctx.selectedDate !== _ctx.convertedDate(_ctx.currentDate),
            }]),
            text: 'Today',
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.today()))
          }, null, 8, ["class"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.time_section_text), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.requiredSymbol), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_time_selector, {
            hour: _ctx.getHour(_ctx.time_suggestion_selected),
            minutes: _ctx.getMinutes(_ctx.time_suggestion_selected),
            hoursStored: _ctx.storedHours,
            minutesStored: _ctx.storedMinutes,
            onCheckSuggestion: _ctx.checkSuggestion
          }, null, 8, ["hour", "minutes", "hoursStored", "minutesStored", "onCheckSuggestion"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.time_suggestions, (suggestion, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "time-suggestion-button-container",
              key: index
            }, [
              _createVNode(_component_ta_button, {
                class: _normalizeClass(["time-suggestion-button", {
                'time-suggestion-button-not-selected':
                  _ctx.time_suggestion_selected !== suggestion,
              }]),
                text: _ctx.generateButtonText(suggestion),
                backgroundColor: 'orange',
                onClick: ($event: any) => (_ctx.selectTimeSuggestions(suggestion))
              }, null, 8, ["class", "text", "onClick"])
            ]))
          }), 128))
        ]),
        (_ctx.time_suggestions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.time_suggestions_text), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}